import React, { Component } from 'react';

class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            domainURL: props.config.DomainURL != "" ? props.config.DomainURL : "https://producermax.com/",
        };
    }
    componentDidMount() {
    };
    render() {
        return (
            <div>
                <footer className="footerTop">
                    <div className="col-md-12 pm_footer_bottom">
                        <div className="container">
                            <p><a href={this.state.domainURL + "/Legal.html"} target="new" className="pm_white">Legal</a> | <a href={this.state.domainURL + "/TermsOfUse.html"} target="new" className="pm_white">Terms and Conditions</a> | <a href={this.state.domainURL + "/PrivacyPolicy.html"} target="new" className="pm_white">Privacy Policy</a> | Copyright &copy; Chum IT LLC</p>
                        </div>
                    </div>
                </footer>
            </div>
        );
    }
}

export default Footer;